import { useAuth } from '@shared/providers/AuthProvider';
import {
    getRepresentativeByCiam,
    getRepresentativeDealerXrefByRepId,
} from '@shared/services/dealer-management-service';
import { useQuery } from '@tanstack/react-query';

export function useRepresentativeXref(repId: string, options?) {
    const { getToken } = useAuth();
    return useQuery(
        ['repById', repId],
        async () => await getRepresentativeDealerXrefByRepId(repId, getToken),
        {
            enabled: !!repId,
            refetchOnMount: false,
            refetchOnReconnect: false,
            refetchOnWindowFocus: false,
            staleTime: 'Infinity',
            cacheTime: 'Infinity',
            ...options,
        }
    );
}

export default function useRepresentative(userId: string, options?) {
    const { getToken } = useAuth();
    return useQuery(
        ['repByCiam', userId],
        async () => await getRepresentativeByCiam(userId, getToken),
        {
            enabled: !!userId,
            refetchOnMount: false,
            refetchOnReconnect: false,
            refetchOnWindowFocus: false,
            staleTime: 'Infinity',
            cacheTime: 'Infinity',
            ...options,
        }
    );
}
